
  export default {
    props: {
      text: { type: String, required: true },
      type: { type: String, default: 'info', validator: s => ['asterisk', 'error', 'info', 'success', 'warning'].includes(s) }
    },
    computed: {
      icon () {
        if (this.type === 'error') {
          return ['far', 'circle-xmark'];
        } else if (this.type === 'success') {
          return ['far', 'circle-check'];
        } else if (this.type === 'warning') {
          return ['far', 'triangle-exclamation'];
        } else if (this.type === 'asterisk') {
          return ['far', 'asterisk'];
        } else {
          return ['far', 'circle-info'];
        }
      }
    }
  };
